import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import Body3Html from './common/Body3Html'
import LegalContainer from './common/LegalContainer'
import List from './common/List'

const t = buildTranslate('legal.settlement_credits')

function SettlementCredits() {
  return (
    <LegalContainer>
      <Text.Header2>{t('title')}</Text.Header2>
      <Body3Html tag="p">{t('intro')}</Body3Html>

      <Text.Header3>1. {t('changes.title')}</Text.Header3>
      <Body3Html tag="p">{t('changes.content')}</Body3Html>

      <Text.Header3>2. {t('credits.title')}</Text.Header3>
      <List prefix="2." items={Object.values(t('credits.items'))} />

      <Text.Header3>3. {t('credit_funding.title')}</Text.Header3>
      <List prefix="3." items={Object.values(t('credit_funding.items'))} />

      <Text.Header3>4. {t('disclaimers.title')}</Text.Header3>
      <Body3Html tag="p">{t('disclaimers.content')}</Body3Html>

      <Text.Header3>5. {t('indemnification.title')}</Text.Header3>
      <Body3Html tag="p">{t('indemnification.content')}</Body3Html>

      <Text.Header3>6. {t('liability.title')}</Text.Header3>
      <Body3Html tag="p">{t('liability.content')}</Body3Html>
    </LegalContainer>
  )
}

export default SettlementCredits
